// Centralized content for lsb-studio.com

export const STUDIO = {
  name: "lsb-studio",
  domain: "lsb-studio.com",
  tagline: "Capturing Life's Most Elegant Moments",
  address: {
    line1: "New York · New Jersey",
    line2: "By appointment",
  },
  phone: "+1 (917) 476-3390",
  phoneWa: "19174763390",
  email: "info@lsb-studio.com",
  hours: "Tue – Sun · 10:00 – 18:00 (By appointment)",
  social: {
    instagram: "https://www.instagram.com/l_s_b_studio/",
    facebook: "https://facebook.com/lsbstudio",
    pinterest: "https://pinterest.com/lsbstudio",
    whatsapp: "https://wa.me/19174763390",
  },
};

// User-provided client photographs
const ASSETS = {
  maternityWoman:
    "https://customer-assets.emergentagent.com/job_5f63ff69-0fdc-498b-9a4b-34a8a3f41139/artifacts/xsmqd748__DSC2162.jpeg",
  maternityCouple:
    "https://customer-assets.emergentagent.com/job_5f63ff69-0fdc-498b-9a4b-34a8a3f41139/artifacts/pw0mi1rp__DSC2229.jpeg",
  weddingOutdoor:
    "https://customer-assets.emergentagent.com/job_5f63ff69-0fdc-498b-9a4b-34a8a3f41139/artifacts/hqqg24qw_WhatsApp%20Image%202026-01-26%20at%2001.11.53.jpeg",
  weddingBW:
    "https://customer-assets.emergentagent.com/job_5f63ff69-0fdc-498b-9a4b-34a8a3f41139/artifacts/qqq5njdy_WhatsApp%20Image%202026-01-26%20at%2001.11.56.jpeg",
  portraitFloral:
    "https://customer-assets.emergentagent.com/job_5f63ff69-0fdc-498b-9a4b-34a8a3f41139/artifacts/utmoulyd_WhatsApp%20Image%202026-01-26%20at%2001.11.54%20%284%29.jpeg",
  portraitGreen:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/6njmru6o_WhatsApp%20Image%202025-12-27%20at%2021.35.23.jpeg",
  eventBW:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/nemv76zl_WhatsApp%20Image%202026-01-26%20at%2001.11.54.jpeg",
  eventGraffiti:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/01lwhr1n_WhatsApp%20Image%202026-01-26%20at%2001.11.56%20%282%29.jpeg",
  eventBeach:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/ifrgz3kv_WhatsApp%20Image%202026-01-26%20at%2001.11.55.jpeg",
  portraitMoody:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/zc7lg4rh_WhatsApp%20Image%202026-01-26%20at%2001.11.55%20%283%29.jpeg",
  portraitPink:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/vcarqaw6_WhatsApp%20Image%202025-12-27%20at%2021.35.24%20%282%29.jpeg",
  eventHoli:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/eocrv3r4_WhatsApp%20Image%202025-12-27%20at%2021.35.24%20%283%29.jpeg",
  portraitLounge:
    "https://customer-assets.emergentagent.com/job_premium-moments-lab/artifacts/97gwuqeo_WhatsApp%20Image%202026-01-26%20at%2001.11.56%20%281%29.jpeg",
};

export { ASSETS };

export const HERO_IMAGE = ASSETS.weddingOutdoor;

export const SERVICES = [
  {
    id: "weddings",
    title: "Weddings",
    blurb:
      "Heirloom imagery for the day you'll relive forever — quiet vows, golden first light, the loudest joy.",
    image: ASSETS.weddingOutdoor,
  },
  {
    id: "maternity",
    title: "Maternity",
    blurb:
      "Tender, editorial portraits honoring the moments before everything changes.",
    image: ASSETS.maternityWoman,
  },
  {
    id: "events",
    title: "Events",
    blurb:
      "Editorial event coverage that reads like a magazine spread — light, story, atmosphere.",
    image: ASSETS.eventBW,
  },
  {
    id: "portraits",
    title: "Portraits",
    blurb:
      "Refined personal and brand portraits sculpted with cinematic light.",
    image: ASSETS.portraitGreen,
  },
];

export const PACKAGES = [
  {
    name: "Basic",
    rows: [
      { location: "Studio", duration: "1 hour", price: "$250", photos: "8", outfits: "2", people: "Max 3", extra: "+$45" },
      { location: "Outdoor", duration: "1 hour", price: "$150", photos: "8", outfits: "2", people: "Max 3", extra: "+$45" },
    ],
  },
  {
    name: "Standard",
    featured: true,
    rows: [
      { location: "Studio", duration: "2 hours", price: "$450", photos: "10", outfits: "2", people: "Max 5", extra: "+$45" },
      { location: "Outdoor", duration: "2 hours", price: "$300", photos: "10", outfits: "2", people: "Max 5", extra: "+$45" },
    ],
  },
  {
    name: "Premium",
    rows: [
      { location: "Any", duration: "3½ hours", price: "$1,500", photos: "50", outfits: "Unlimited", people: "Unlimited", extra: "+$10 / photo" },
    ],
  },
];

export const ADD_ONS = [
  { label: "Printed Photo Album", value: "$400" },
  { label: "Photo Delivery (digital)", value: "Included" },
  { label: "Customized Online Gallery", value: "Included" },
  { label: "Printing Rights", value: "Included" },
  { label: "Album Delivery", value: "Within 3 weeks" },
];

export const GALLERY = [
  { src: ASSETS.portraitFloral, span: "md:col-span-2 row-span-2", category: "Wedding", fit: "cover", focus: "center" },
  { src: ASSETS.maternityWoman, span: "", category: "Maternity" },
  { src: ASSETS.eventBW, span: "", category: "Events" },
  { src: ASSETS.weddingOutdoor, span: "row-span-2", category: "Wedding" },
  { src: ASSETS.maternityCouple, span: "", category: "Maternity" },
  { src: ASSETS.eventGraffiti, span: "", category: "Events" },
  { src: ASSETS.eventBeach, span: "", category: "Events" },
  { src: ASSETS.eventHoli, span: "row-span-2", category: "Events" },
  { src: ASSETS.portraitGreen, span: "row-span-2", category: "Portraits", fit: "cover", focus: "center" },
  { src: ASSETS.portraitMoody, span: "row-span-2", category: "Portraits" },
  { src: ASSETS.portraitLounge, span: "", category: "Portraits" },
  { src: ASSETS.portraitPink, span: "", category: "Portraits", fit: "cover", focus: "center" },
  { src: ASSETS.weddingBW, span: "", category: "Portraits", fit: "cover", focus: "center" },
];

export const TESTIMONIALS = [
  {
    quote:
      "They didn't just photograph our wedding — they remembered it for us. Every frame is a feeling we get to keep forever.",
    author: "Amara & Daniel",
    context: "Wedding · Atlanta",
  },
  {
    quote:
      "I have never felt more seen in front of a camera. The maternity session was tender, patient, and impossibly beautiful.",
    author: "Naomi K.",
    context: "Maternity",
  },
  {
    quote:
      "Editorial, calm, deeply professional. lsb-studio delivered images our brand still leads with two years later.",
    author: "Studio Maren",
    context: "Brand Portraits",
  },
];

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "pricing", label: "Pricing" },
  { id: "gallery", label: "Gallery" },
  { id: "testimonials", label: "Voices" },
  { id: "contact", label: "Contact" },
];

export const EXTERNAL_LINKS = [
  { to: "/book", label: "Book" },
];
